export default {
      id: "select-usage",
      viewBox: "0 0 252 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#select",
      toString: function () {
        return this.url;
      }
    }